module.exports = __webpack_public_path__ + "static/2-first-login-734123283fb3f3e9b179e5efbfe9f24a.jpg";